import React, { useState , useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import { ToastContainer , toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Form from '../../../common/forms/Form';
import {newTrustScore} from '../../../../services/trustScore/trustScoreService'
import Loading from '../../../common/loading/Loading';

const AddCoin = () => {
  
    const navigate = useNavigate();

    const[loading , setLoading] = useState(false);
    const [loadingForm , setLoadingForm] = useState(false);
    const [ form , setForm ]= useState({
        formItems: [
        {
            inputType: "input",
            config: {
                label: 'Title',
                name: "title",
                containerClasses : 'w-full'
            },
            value: '',
            validation: {
                required: true,
            },
            valid: false,
            errorMsg: "",
            used: false
        },
        {
            inputType: "input",
            config: {
                label: 'H1',
                name: "h1",
                containerClasses : 'w-full'
            },
            value: '',
            validation: {
                required: true,
            },
            valid: false,
            errorMsg: "",
            used: false
        },
        {
            inputType: "input",
            config: {
                label: 'Blog Header',
                name: "blogHeader",
                containerClasses : 'w-full'
            },
            value: '',
            validation: {
                required: true,
            },
            valid: false,
            errorMsg: "",
            used: false
        },
        {
            inputType: "input",
            config: {
                label: 'Slug',
                name: "slug",
                containerClasses : 'w-full'
            },
            value: '',
            validation: {
                required: true,
            },
            valid: false,
            errorMsg: "",
            used: false
        },
        {
            inputType: "input",
            config: {
                label: 'Seo Description',
                name: "seoDesc",
                containerClasses : 'w-full'
            },
            value: '',
            validation: {
                required: true,
            },
            valid: false,
            errorMsg: "",
            used: false
        },
        {
            inputType: "textarea",
            config: {
                label: 'Keywords',
                name: "keywords",
                containerClasses : 'w-full'
            },
            value: '',
            validation: {
                required: true,
            },
            valid: false,
            errorMsg: "",
            used: false
        },
        {
            inputType: "ck-editor",
            config: {
                label: 'Body',
                name: "body",
                containerClasses : 'w-full'
            },
            value: "",
            validation: {
                required: true,
            },
            valid: false,
            errorMsg: "",
            used: false
        },
        {
            inputType: "input-file",
            config: {
                label: 'Image',
                name: "images",
                type: "file",
                t_label : 'attached_file',
                containerClasses : 'w-full'
            },
            value: "",
            validation: {
                maxSize: 5000000,
                isSelected : true ,
            },
            valid: false,
            errorMsg: "",
            used: false
        },
        {
            inputType: "input",
            config: {
                label: 'faq Title',
                name: "faqTitle",
                containerClasses : 'w-full'
            },
            value: '',
            validation: {
            },
            valid: false,
            errorMsg: "",
            used: false
        },
        {
            inputType: "faq",
            config: {
                label: 'FAQ',
                name: "faq",
                containerClasses : 'w-full'
            },
            value: [],
            validation: {
            },
            valid: false,
            errorMsg: "",
            used: false
        },
    ]
    });
    


    const handleSubmitForm = async(formData)=>{

        try{
            //const {data} = await axiosApiInstance.post(`/admin/blog/new` , formData) ;
            const {data} = await newTrustScore(formData) ;
            setLoadingForm(true);
            if(data.status === 'success'){
                toast.success('Your new post sended successfull');
                navigate('/trust-score')

            }else if(data.status == 'error'){
                toast.error(data.msg);
            }

        }catch(err){
            toast.error(err.response.data.message);
            setLoadingForm(true);
        }

    }


    return (
        <>
            <ToastContainer 
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored" />


            <div className="container mx-auto p-3 ">
                <div className='bg-white-100 dark:bg-dark-100 p-3 rounded-md text-[0.9rem] font-normal flex flex-col justify-center items-start shadow-my dark:shadow-none '>
                    <div className='w-full flex justify-start items-center mb-5'>
                        <svg className='w-2 h-2 fill-gray-700 mr-2' viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="50" cy="50" r="50" />
                        </svg>
                        <span className='text-gray-700 text-xl font-extrabold'>New Coin</span>
                    </div>

                    {
                        loading ?
                        (
                            <Loading/> 
                        )
                        :
                        (
                            <Form initForm={form} classes={'gap-[20px]'} submit={handleSubmitForm} loading={loadingForm} submitTitle="Send" file={true}/>

                        )

                    }
                              
                </div>
            </div>
        </>
    )

}

export default AddCoin ;
